module.exports = __webpack_public_path__ + "static/media/phoneBlue.44c6e9ce.svg";